import { Button, Card, Grid, Typography } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import HeaderMenu from "../../components/ui-elements/header";
import { Utils } from "../../resources/util";
import { useStyles } from "./styles";
import { useMediaQuery } from 'react-responsive';

const NrgPackages = (props) => {
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const amount = params.get('amount')
  const postcode = params.get('postcode')
  const classes = useStyles();
  const [packageData, setPackageData] = useState([]);
  const [rowData, setRowData] = useState(undefined);
  const [originalRecommendation, setOriginalRecommendation] = useState(undefined);
  const rowKeys = {
    currentQuarterlyBill: "Your current quarterly bill",
    systemSize: "System size",
    estimatedYearlySavings: "Estimated yearly savings",
    fortnightlyPayments: "Fortnightly payments of (5 years)"
  }
  const recommnededTagIcon = require("../../resources/images/recommended.png");
  const recommnededTag = require("../../resources/images/recommended1.png");

  // Fetch packages
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(
          `${Utils.getBaseApiUrl()}/packages`,
          { params: { currentQuarterlyBill: amount } }
        );
        if (isMobile) {
          const recPkg = response.data.find(o => o.recommendedPackage);
          const sortedPkgList = response.data.filter(o => !o.recommendedPackage);
          sortedPkgList.unshift(recPkg);
          setPackageData(sortedPkgList)
        } else {
          setPackageData(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    })()
  }, []);

  useEffect(() => {
    if (packageData.length && !originalRecommendation) {
      setOriginalRecommendation(packageData.find(o => o.recommendedPackage));
    }
  }, [packageData])

  // Construct row data
  useEffect(() => {
    if (packageData) {
      const obj = {};
      Object.keys(rowKeys).forEach(k => {
        obj[k] = packageData.map((item) => {
          return {
            pkg: item.packageName,
            val: item[k],
            recommendedPackage: item.recommendedPackage,
            pkgId: item.id
          }
        })
      });
      if (props.location.state.showFortnightlyPayments !== 'true') {
        delete obj.fortnightlyPayments
      }
      setRowData(obj);
    }
  }, [packageData])

  // Package change handler
  const onPackageChange = (newPackageId) => {
    const updatedPackageData = [...packageData];

    packageData.forEach((pkg, i) => {
      if (pkg.recommendedPackage) {
        if (pkg.id === newPackageId) {
          // Same pckage selected
          return;
        }
        // Remove last known recommended package
        updatedPackageData[i].recommendedPackage = false;
      }
      if (pkg.id === newPackageId) {
        // Set new recommendation
        updatedPackageData[i].recommendedPackage = true;
      }
    });

    setPackageData(updatedPackageData);
  }

  // "Send me information..." button click handler
  const redirectToQuotationForm = () => {
    const obj = packageData.find(o => o.recommendedPackage);
    const url = `https://www.nrgsolar.com.au/quotation?postcode=${postcode}&qtry_bills=${amount}&system_size=${obj.systemSize}&fn_payment_budget=${obj.fortnightlyPayments}`;
    window.open(url);
  };

  return (
    <Grid className={classes.root}>
      <HeaderMenu />
      {packageData.length ?
        <div>
          <Grid item xs={12}>
            <Typography variant="h6" className={classes.detailTitle}>
              Sounds like your average quarterly bill is ${Utils.formatCurrency(amount)}
            </Typography>
            <Typography variant="h6" className={classes.detailTitle2}>
              The NRG Premium Solar Package that would best suit you is
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {!isMobile ?
              <div className={classes.tableContainer}>
                <Table className={classes.table} size="medium" align="center" aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" className={classes.tableHead2}></TableCell>
                      {packageData && packageData.map((row, i) =>
                        <TableCell
                          key={i}
                          align="center"
                          className={`${row.recommendedPackage && classes.selectedThCell} ${classes.tableHead}`}
                          onClick={() => onPackageChange(row.id)}>
                          {(originalRecommendation && originalRecommendation.id === row.id) &&
                            <div className={classes.recommendedPackage}>
                              <div className={classes.recommnededTagIcon}>
                                <img src={recommnededTag} alt="Recommended" />
                              </div>
                              <div>Recommended</div>
                            </div>
                          }
                          {row.packageName}
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowData && Object.keys(rowData).map((row, i, rowArr) =>
                      <TableRow key={i}>
                        <TableCell align="center" className={classes.tableHead3}>{rowKeys[row]}</TableCell>
                        {
                          rowData[row].map((cell, idx) =>
                            <TableCell
                              key={idx} align="center"
                              className={`${cell.recommendedPackage && classes.selectedTdCell} ${cell.recommendedPackage && i === rowArr.length - 1 && classes.lastSelectedTdCell}`}
                              onClick={() => onPackageChange(cell.pkgId)}>
                              {`${row !== "systemSize" ? "$" : ""}${isNaN(cell.val) ? cell.val : Math.floor(cell.val)}`}
                            </TableCell>
                          )
                        }
                      </TableRow>
                    )
                    }
                  </TableBody>
                </Table>
              </div>
              :
              <div className={classes.mobileViewContainer}>
                <div className={classes.recommendedPackageMobileView}>
                  <img style={{ marginRight: '3px' }} src={recommnededTagIcon} alt="Recommended" />
                  Recommended
                </div>
                {
                  packageData && packageData.map((nrgPackage, i) =>
                    <Card className={`${nrgPackage.recommendedPackage && classes.selectedMobileCard} ${classes.mobileViewCard}`} elevation={10} key={i}>
                      <Grid item xs={12} onClick={() => onPackageChange(nrgPackage.id)}>
                        <Grid key={i} container justifyContent="center" spacing={1}>
                          <Grid xs={6} item>
                          </Grid>
                          <Grid xs={6} container justifyContent="center" item className={`${classes.mobileViewCardCell} ${classes.mobileViewCardPkg}`}>
                            {nrgPackage.packageName}
                          </Grid>
                        </Grid>
                        {rowData && Object.keys(rowData).map((row, i) =>
                          <Grid key={i} container justifyContent="center" spacing={1}>
                            <Grid xs={6} className={classes.mobileViewCardCellHeader} item>
                              <div>{rowKeys[row]}</div>
                            </Grid>
                            <Grid xs={6} container alignContent="center" justifyContent="center" item className={classes.mobileViewCardCell}>
                              <div>
                                {`${row !== "systemSize" ? "$" : ""}${nrgPackage[row]}`}
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Card>
                  )
                }
              </div>
            }
          </Grid>
          <Grid item xs={12} className={`${isMobile && classes.continueButtonContainer}`}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => redirectToQuotationForm()}
              className={classes.continueButton}
              size="large">
              Send me information about this system
            </Button>
          </Grid>
        </div>
        : <div className={classes.loader}>
          <Loader type="Circles" color="#FB7906" height={80} width={80} />
        </div>
      }
    </Grid >
  );
}

export default NrgPackages;